import { render, staticRenderFns } from "./ConLiquidationData.vue?vue&type=template&id=1d871eae"
import script from "./ConLiquidationData.vue?vue&type=script&lang=js"
export * from "./ConLiquidationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports